import { SetStateAction } from 'react';

import { DecisionIQSurveyQuestionDto } from 'enrollment/queries';

export const insertOrRemoveValues = (
  dependentId: string,
  currentIsChecked: string[]
) => {
  if (!currentIsChecked) {
    currentIsChecked = [];
  }

  if (currentIsChecked.includes(dependentId)) {
    return currentIsChecked.filter((id) => id !== dependentId);
  } else {
    return [...currentIsChecked, dependentId];
  }
};

export const getUtilizationIndex = (index: number) => {
  switch (index) {
    case 0:
      return 3;
    case 1:
      return 2;
    case 2:
      return 1;
    default:
      return 0;
  }
};

export const collectDocFrequencyValues = (
  question: DecisionIQSurveyQuestionDto,
  dependentIds: number[] | undefined
) => {
  const frequenciesSubscriber = document.querySelectorAll(
    'input[type="radio"][name="radio-subscriber"]'
  );
  let frequenciesDependents: NodeList[] = [];

  if (dependentIds) {
    frequenciesDependents = dependentIds.map((id) => {
      return document.querySelectorAll(
        `input[type="radio"][name="radio-dep-${id}"]`
      );
    });
  }
  let subIndex = -1;
  frequenciesSubscriber.forEach((radio, index) => {
    if ((radio as HTMLInputElement).checked) {
      subIndex = getUtilizationIndex(index);
    }
  });

  const depIndicies = new Array(dependentIds?.length).fill(-1);
  if (frequenciesDependents.length > 0) {
    dependentIds?.forEach((id, depIndex) => {
      frequenciesDependents[depIndex].forEach((radio, index) => {
        if ((radio as HTMLInputElement).checked) {
          depIndicies[depIndex] = getUtilizationIndex(index);
        }
      });
    });
  }

  // time to update the question object
  const newQuestion = { ...question };
  newQuestion.options.forEach((option) => {
    if (subIndex > 0 && String(option.id) === `utilization[${subIndex}]`) {
      option['is_checked?'] = option['is_checked?'].includes('emp')
        ? option['is_checked?']
        : [...option['is_checked?'], 'emp'];
    } // we have a hit for the index, but we need to clear old values
    else if (subIndex > 0) {
      option['is_checked?'] = option['is_checked?'].filter(
        (id) => id !== 'emp'
      );
    }
    if (dependentIds) {
      depIndicies.forEach((depIndex, loopIndex) => {
        if (depIndex > 0 && String(option.id) === `utilization[${depIndex}]`) {
          option['is_checked?'] = option['is_checked?'].includes(
            String(dependentIds[loopIndex])
          )
            ? option['is_checked?']
            : [...option['is_checked?'], String(dependentIds[loopIndex])];
        } // we have a hit for the index, but we need to clear old values
        else if (depIndex > 0) {
          option['is_checked?'] = option['is_checked?'].filter(
            (id) => id !== String(dependentIds[loopIndex])
          );
        }
      });
    }
  });
  return newQuestion;
};

export const addPrescriptionValues = (
  question: DecisionIQSurveyQuestionDto,
  subPrescriptions: string[],
  depPrescriptions: { [key: number]: string[] }
) => {
  const newQuestion = { ...question };
  newQuestion.options[0].value = {
    emp: subPrescriptions,
    ...depPrescriptions,
  };
  return newQuestion;
};

export const initPrescriptionValues = (
  dependentIds: number[],
  prescriptionQs: DecisionIQSurveyQuestionDto | undefined,
  initArray: any[],
  setSubscriberPrescriptions: (value: SetStateAction<string[]>) => void,
  setDependentPrescriptions: (
    value: SetStateAction<{
      [key: number]: string[];
    }>
  ) => void,
  setShowPrescriptionDeps: (value: SetStateAction<boolean>) => void,
  setShowPrescriptionSearch: (
    value: SetStateAction<boolean[] | undefined>
  ) => void
) => {
  const dependentPrescriptions: { [key: number]: string[] } = {};
  dependentIds.forEach((depId) => {
    dependentPrescriptions[depId] = new Array<string>();
  });
  if (
    prescriptionQs &&
    prescriptionQs.options[0].value &&
    typeof prescriptionQs.options[0].value !== 'string'
  ) {
    Object.entries(prescriptionQs.options[0].value).forEach(([key, value]) => {
      if (dependentIds?.includes(Number(key)) && value.length > 0) {
        initArray[dependentIds.indexOf(Number(key)) + 1] = true;
        dependentPrescriptions[Number(key)] = value;
      } else if (key === 'emp' && value.length > 0) {
        initArray[0] = true;
        setSubscriberPrescriptions(value);
      }
    });
    setDependentPrescriptions(dependentPrescriptions);
  }
  setShowPrescriptionDeps(initArray.some((val) => val));
  setShowPrescriptionSearch(initArray);
};
